module.exports = new __parcel__URL__("idea.877bae0a.svg").toString();